<template>
  <div class="upload-pic">
    <el-upload
      class="avatar-uploader"
      :action="baseUrl"
      :show-file-list="false"
      :style="'width:' + width + 'px;height:' + height + 'px'"
      :class="myUrl ? 'pic' : ''"
      :disabled="isUploadDisabled"
      :on-success="handleAvatarSuccess"
      :on-change="onHandelImageSelect"
      :on-error="fail"
      :before-upload="beforeAvatarUpload"
      list-type="picture"
      :on-progress="uploadVideoProcess"
      :multiple="false"
      :headers="config"
    >
      <el-image
        v-if="myUrl && videoFlag == false && isVideo == true"
        :src="`${myUrl}?vframe/jpg/offset/0`"
        class="avatar"
        fit="fill"
        :class="round ? 'round' : ''"
        :style="'width:' + width + 'px;height:' + height + 'px'"
      />
      <!-- <el-image v-if="myUrl&& videoFlag == false&&isMp3==true" :src="myUrl" class="avatar" fit="fill" :class="round?'round':''" :style="'width:' + width + 'px;height:' + height +'px'" /> -->
      <el-image
        v-else-if="myUrl && videoFlag == false && isVideo == false"
        :src="myUrl"
        class="avatar"
        fit="fill"
        :class="round ? 'round' : ''"
        :style="'width:' + width + 'px;height:' + height + 'px'"
      />
      <i
        v-else-if="!myUrl && videoFlag == false"
        class="el-icon-plus avatar-uploader-icon"
        :style="'font-size:' + width / 2 + 'px'"
      />
      <el-progress
        v-if="videoFlag == true"
        type="circle"
        :percentage="videoUploadPercent"
        style="margin-top: 30px"
      />
    </el-upload>

    <div v-if="showImageActions" class="image-actions">
      <el-button type="text" size="mini" @click.stop="handlePreview">
        预览
      </el-button>
      <el-button type="text" size="mini" @click.stop="handleRemove">
        删除
      </el-button>
    </div>

    <el-dialog
      title="图片预览"
      :visible.sync="previewVisible"
      append-to-body
      width="520px"
    >
      <img :src="myUrl" alt="preview" class="preview-image" />
    </el-dialog>
  </div>
</template>
<script>
/**
 * @imageUrl 当前图片地址或者上传后的图片地址
 * @width 组件的宽度
 */
import environment from '@/utils/environment'
export default {
  props: {
    myUrl: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 40
    },
    height: {
      type: [Number, String],
      default: 40
    },
    round: {
      type: Boolean,
      default: false
    },
    isVideo: {
      type: Boolean,
      default: false
    },
    enablePreviewDelete: {
      type: Boolean,
      default: false
    }
    // isMp3:{
    //   type: Boolean,
    //   default: false
    // },
  },
  data() {
    return {
      baseUrl: '',
      videoFlag: false, // 进度条
      videoUploadPercent: null,
      previewVisible: false,
      config: {
        Authorization: localStorage.getItem('token')
      }
    }
  },
  computed: {
    isUploadDisabled() {
      return this.enablePreviewDelete && !!this.myUrl && this.videoFlag === false
    },
    showImageActions() {
      return (
        this.enablePreviewDelete &&
        !!this.myUrl &&
        this.videoFlag === false &&
        this.isVideo === false
      )
    }
  },
  mounted() {
    this.baseUrl = environment.upLoadPath()
    console.log(this.myUrl, 'myUrl')
  },
  methods: {
    beforeAvatarUpload(file) {
      // 上传前的函数
      // const size = Math.floor(file.size)
      // if (size > 50 * 1024 * 1024) {
      //   this.$message.error('请选择50M以内的文件')
      //   return false
      // }
      if (this.isVideo) {
        if (file.type !== 'video/mp4') {
          this.$message.error('请选择MAP4格式的文件')
          return false
        }
      }
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file, '00000')
      this.videoFlag = false
      this.myUrl = URL.createObjectURL(file.raw)
      if (this.isVideo) {
        this.myUrl = res.url
      } else {
        this.myUrl = URL.createObjectURL(file.raw)
      }
      this.$emit('upLoadImage', res.url)
    },
    fail(err, file) {
      this.videoFlag = false
      this.$message.error(err || '服务器错误，请稍后重试')
    },
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = parseInt(file.percentage)
    },
    init(url) {
      console.log('晴空', url)
      this.myUrl = url
    },
    onHandelImageSelect(e, file) {
      // console.log("changeImage",file)
      this.$emit('changeImage', e, file)
    },
    handlePreview() {
      if (!this.myUrl) return
      this.previewVisible = true
    },
    handleRemove() {
      if (!this.myUrl) return
      this.$confirm('确认删除当前图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.previewVisible = false
          this.$emit('upLoadImage', '')
          this.$emit('removeImage')
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-pic {
  display: inline-block;
}
.avatar-uploader {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #999999;
  margin-left: 10px;
  // border-radius: 10px;

  .round {
    // border-radius: 50%;
  }
}
.pic {
  border: none;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.image-actions {
  display: flex;
  align-items: center;
  margin-top: 4px;
  margin-left: 10px;
}
.preview-image {
  display: block;
  width: 100%;
  max-height: 60vh;
  object-fit: contain;
}
</style>
